import { render } from "./GymStatsTab.vue?vue&type=template&id=2ac68ad8&scoped=true"
import script from "./GymStatsTab.vue?vue&type=script&lang=js"
export * from "./GymStatsTab.vue?vue&type=script&lang=js"

import "./GymStatsTab.vue?vue&type=style&index=0&id=2ac68ad8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ac68ad8"]])

export default __exports__